import { type ActionEvent, Controller } from "@hotwired/stimulus";

// Connects to data-controller="map-scene-picker"
// The Criar mapa dialog: the cards, then the chosen card's panel.
export default class extends Controller {
	static targets = ["step"];
	declare readonly stepTargets: HTMLElement[];

	show({ params: { step } }: ActionEvent) {
		const first = this.reveal(step)?.querySelector<HTMLElement>("input:not([type=hidden]), button, a[href]");
		first?.focus();
		if (first instanceof HTMLInputElement && first.type === "text") first.select();
	}

	reset() {
		this.reveal("choose");
	}

	reveal(step: string) {
		for (const target of this.stepTargets) target.hidden = target.dataset.step !== step;
		return this.stepTargets.find((target) => !target.hidden);
	}
}
